/** PortalsHubRoute — skin-aware switcher for /portals. */
import { useUISkin } from "@/data/UISkinContext";
import PortalsHub from "./PortalsHub";
import { CockpitFrame } from "@/components/cockpit/CockpitFrame";

export default function PortalsHubRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") {
    return (
      <CockpitFrame eyebrow="Customer · Portals" title="Portals Hub">
        <PortalsHub />
      </CockpitFrame>
    );
  }
  return <PortalsHub />;
}
